import { Component, Input, OnDestroy } from '@angular/core'
import { BehaviorSubject, Subscription } from 'rxjs'
import {
  ColDef,
  GetRowIdFunc,
  GridApi,
  GridReadyEvent,
} from 'ag-grid-community'
import { AgGridAngular } from 'ag-grid-angular'
import { TableLoadingOverlayComponent } from './overlays/table-loading-overlay.component'
import { TableNoDataOverlayComponent } from './overlays/table-no-data-overlay.component'
import { TableSortService } from './services/table-sort.service'
import { IntervalUsageHistory } from 'src/app/shared/models/intervalUsageHistory'
import { IntervalUsageHistoryColumnDefinition } from './definitions/interval-usage-history-column-definition'

@Component({
  selector: 'app-interval-usage-history-table',
  imports: [AgGridAngular],
  providers: [TableSortService],
  styles: `
      :host {
          display: flex;
          flex-direction: column;
          justify-content: start;
      }
    `,
  template: `
    <ag-grid-angular
      class="app-table"
      style="height: 40vh"
      [getRowId]="getRowId"
      [columnDefs]="columnDefs"
      [rowData]="[]"
      [suppressPaginationPanel]="true"
      [suppressDragLeaveHidesColumns]="true"
      [loadingOverlayComponent]="loadingOverlayComponent"
      [noRowsOverlayComponent]="noRowsOverlayComponent"
      [noRowsOverlayComponentParams]="noRowsOverlayParams"
      [pagination]="false"
      [enableCellTextSelection]="true"
      [loading]="loading"
      (gridReady)="onGridReady($event)"
    />
  `,
})
export class IntervalUsageHistoryTableComponent
implements OnDestroy
{
  private subscription = new Subscription()
  private loading$ = new BehaviorSubject(false)
  private data$ = new BehaviorSubject<IntervalUsageHistory[]>([])

  @Input() set loading(val: boolean) {
    this.loading$.next(val)
  }

  get loading(): boolean {
    return this.loading$.getValue()
  }

  @Input() set data(val: IntervalUsageHistory[] | null) {
    if(val) {
      this.data$.next(val)
    }
  }

  public gridApi: GridApi

  getRowId: GetRowIdFunc<IntervalUsageHistory> = (data) =>
    data.data.service_point_uid + data.data.market_interval

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api
    this.init()
  }

  private init() {
    this.subscription.add(
      this.data$.subscribe((data) => {
        const nodeData: unknown[] = []
        this.gridApi?.forEachNode((node) => nodeData.push(node.data))
        this.gridApi?.applyTransaction({
          remove: nodeData,
          add: data,
        })
        this.gridApi.hideOverlay()
        if (!data.length) {
          this.gridApi?.forEachNode((node) => nodeData.push(node.data))
          this.gridApi?.applyTransaction({
            remove: nodeData,
          })
          this.noRowsOverlayParams = { error: false }
          this.gridApi.showNoRowsOverlay()
        }
      }),
    )
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  // columns
  public loadingOverlayComponent = TableLoadingOverlayComponent
  public noRowsOverlayComponent = TableNoDataOverlayComponent
  public noRowsOverlayParams = { error: false }

  columnDefinition = new IntervalUsageHistoryColumnDefinition()

  public columnDefs: ColDef[] =
    this.columnDefinition.getColDefs()
}
